import styled from 'styled-components';
import { SYS_COLOR_CANVAS_DEFAULT_LIGHT } from '@oneaudi/unified-web-common';
import type { LayerTypes } from './globals';
import { ALERT, FOCUS_LARGE, FOCUS_SMALL, FULLSCREEN } from './globals';
import { responsiveStyles } from '../utils/responsiveStyles';
import { breakpoints } from '../utils/breakpoints';

const stylesContent = {
  [ALERT]: {
    m: '32px 48px 48px 48px',
    s: '32px 28px 28px 28px',
    xs: '32px 16px 16px 16px',
  },
  [FOCUS_LARGE]: {
    l: '48px 60px 60px 60px',
    m: '48px 48px 48px 48px',
    s: '48px 28px 28px 28px',
    xs: '48px 16px 16px 16px',
  },
  [FOCUS_SMALL]: {
    l: '48px 60px 60px 60px',
    m: '48px 48px 48px 48px',
    s: '48px 28px 28px 28px',
    xs: '48px 16px 16px 16px',
  },
  [FULLSCREEN]: {
    xs: '0px 0px 0px 0px',
  },
};

const OneLayerContent = styled.div<{ type: LayerTypes; hasPadding?: boolean }>`
  background-color: var(${SYS_COLOR_CANVAS_DEFAULT_LIGHT});

  // default display padding true
  ${({ type, hasPadding = true }): string =>
    stylesContent[type] &&
    responsiveStyles({ padding: hasPadding ? stylesContent[type] : '0' }, breakpoints)}
`;

export default OneLayerContent;
